import { section } from '@/glow';
import { Loader } from '@googlemaps/js-api-loader';

import { add, remove, qs, qsa } from '@fluorescent/dom';
import { AnimateMap } from '@/lib/animation';

const selectors = {
  mapContainer: '.map__container',
  map: '.map__element',
  image: '.map__image',
};

const classes = {
  hidden: 'hidden',
};

section('map', {
  onLoad() {
    this.AnimateMap = AnimateMap(this.container);

    const map = qs(selectors.mapContainer, this.container);
    let geocoder = null;

    if (!map) return;

    const { apiKey, address } = map.dataset;

    const rawData = qs('#map-styles', this.container).innerHTML;

    let styleData;

    if (rawData) {
      try {
        styleData = JSON.parse(rawData);
      } catch (e) {
        styleData = {};
        console.error(`Custom map JSON error: ${e}`);
      }
    }

    if (!apiKey || !address) return;

    const _setFailureHandler = () => {
      // Handle authetication errors
      window.gm_authFailure = function () {
        const maps = qsa(selectors.mapContainer, document);
        const mapImages = qsa(selectors.image, document);

        maps.forEach(map => {
          add(map, classes.hidden);
        });

        mapImages.forEach(img => {
          remove(img, classes.hidden);
        });
      };
    };

    const _loadMap = () => {
      add(qs(selectors.image, this.container), classes.hidden);
      geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address }, (res, _) => {
        const { location } = res[0].geometry;
        const latLong = { lat: location.lat(), lng: location.lng() };
        const map = new google.maps.Map(qs(selectors.map, this.container), {
          center: latLong,
          zoom: 12,
          styles: styleData.styles,
        });
        new google.maps.Marker({
          position: latLong,
          map,
        });
      });
    };

    const _loadAPI = (apiKey, address, styleData) => {
      const loader = new Loader({
        apiKey,
        version: 'weekly',
      });

      // Only load the api once
      if (!window.google) {
        loader.load().then(() => {
          _loadMap(address, styleData);
        });
      } else {
        _loadMap(address, styleData);
      }
    };

    _setFailureHandler();
    _loadAPI(apiKey, address, styleData);
  },

  onUnload() {
    this.AnimateMap?.destroy();
  },
});
